import request from '@/utils/request'

export function getClients() {
  return request({
    url: '/clients',
    method: 'get',
  })
}
